import { useEffect, useCallback } from "react";
import useEventHandler from "./useEventHandler";
import useGA from "./useGA";

export default () => {
  const { trackPageView, initialize } = useGA();

  useEffect(() => {
    initialize();
  }, []);

  useEventHandler(
    "routeChange",
    useCallback(event => {
      const { newRoute, initial } = event.detail;
      if (!initial) trackPageView(`/${newRoute.url}`);
    }, [])
  );
};
